<template>
  <section class="tabs">
    <div class="tab left" :class="{ inactive: activeTab != 'left' }">
      <slot name="left-tab"></slot>
    </div>
    <div class="divider" :class="{ flip: activeTab != 'left' }"></div>
    <div class="tab right" :class="{ inactive: activeTab != 'right' }">
      <slot name="right-tab"></slot>
    </div>
  </section>
</template>

<script>
export default {
  props: ['activeTab']
}
</script>

<style lang="scss" scoped>
.tabs {
  display: flex;
  height: 35px;
  width: 100%;
  border-radius: 40px 40px 0 0;
  overflow: hidden;
}

.flip {
  transform: scaleX(-1);
}

.tab {
  //flex-grow: 1;
  width: calc(50% - 15px);
  overflow: hidden;

  &.tab.left ::v-deep(button) {
    padding-left: 17px;
  }

  &.tab.right ::v-deep(button) {
    padding-right: 17px;
  }

  &.inactive {
    background-image: url('@/images/tabs/tab-bg-inactive.png');
    background-size: contain;
    button {
      color: #4f4f4f;
    }
  }
}

.divider {
  width: 31px;
  flex-grow: 0;
  flex-shrink: 0;
  background-image: url('@/images/tabs/tab-center.png');
  background-size: contain;
}
</style>
